module.exports = __webpack_public_path__ + "img/employees.01665c08.svg";